import Operation from './Operation.js';

class ResizeEvent extends Operation {
    constructor(mix, event, difference, inPlace) {
        super(mix, event.getType());

        this.event = event;
        this.difference = difference;
        this.inPlace = inPlace;
    }

    execute() {
        this.event.duration = this.getDuration(this.event);
        let steps = this.events.map(x => x.step);

        if (this.differeence=== 0) {
            return;
        }

        let toDelete = undefined;
        for (let i=0; i < this.events.length; i++) {
            let eventToChange = this.events[i];
            if (eventToChange.step > this.event.step) {
                eventToChange.step += this.difference;

                let nextEvent = this.events[i+1];
                if (nextEvent && (nextEvent.step <= eventToChange.step)) {
                    toDelete = i;
                }
                if (this.inPlace) {
                    break;
                }
            }
        }

        if (toDelete !== undefined) {
            this.events.splice(toDelete, 1);
        }
        steps = this.events.map(x => x.step);

        this.calculateDurations();
    }
}

export default ResizeEvent;
